

import React, { useState, useEffect } from "react";
import axios from "axios";
import "./uploadEvent.css";

const UploadEvent = () => {
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [images, setImages] = useState([]);

  // Fetch all uploaded images
  const fetchImages = async () => {
    try {
      const res = await axios.get(process.env.REACT_APP_API_URL+"/admin/eventposter");
      setImages(res.data);
    } catch (err) {
      console.error("❌ Error fetching images:", err);
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  // Handle upload
  const handleUpload = async (e) => {
    e.preventDefault();
    if (!title || !file) {
      alert("Please provide a title and select an image!");
      return;
    }

    const formData = new FormData();
    formData.append("name", title);
    formData.append("file", file);

    try {
      await axios.post(process.env.REACT_APP_API_URL+"/admin/eventposter", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setTitle("");
      setFile(null);
      fetchImages();
    } catch (err) {
      console.error("❌ Error uploading image:", err);
    }
  };

  // Handle delete
  const handleDelete = async (id) => {
    try {
      await axios.delete(process.env.REACT_APP_API_URL+`/admin/eventposter/${id}`);
      fetchImages();
    } catch (err) {
      console.error("❌ Error deleting image:", err);
    }
  };

  return (
    <div className="upload-container">
      <h2>Upload Event Poster</h2>

      <form className="upload-form" onSubmit={handleUpload}>
        <input
          type="text"
          placeholder="Enter Poster Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setFile(e.target.files[0])}
        />
        <button type="submit">Upload</button>
      </form>

      <h3>Uploaded Posters</h3>
      <div className="image-grid">
        {images.length === 0 ? (
          <p>No posters uploaded yet.</p>
        ) : (
          images.map((img) => (
            <div key={img._id} className="image-card">
              <img
                src={process.env.REACT_APP_API_URL+`/admin/eventposter/${img._id}`}
                alt={img.name}
              />
              <p>{img.name}</p>
              <button
                className="delete-btn"
                onClick={() => handleDelete(img._id)}
              >
                🗑
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default UploadEvent;
